import { HttpClient } from  '@angular/common/http';
import {Injectable} from "@angular/core";
import {Observable, of} from "rxjs/index";
import {AuthHttp} from "angular2-jwt";
import {environment} from "../../../environments/environment";
import {BusinessDto} from "../../model/business/dto/business-dto";
import {MenuDto} from "../../model/menu/dto/menu-dto.model";
import {BankAccountDto} from "../../model/business/dto/bank-account-dto";
import {PreferencesDto} from "../../model/preferences/dto/preferences-dto.model";
import {AddressDto} from "../../model/business/dto/address-dto";

@Injectable({
  providedIn: 'root'
})
export class BusinessService {

  public selectedBusinessDTO: BusinessDto;

  constructor(private authHttp: AuthHttp,
              private http: HttpClient) {
  }

  public setSelectedBusiness(selectedBusinessDTO: BusinessDto) {
    this.selectedBusinessDTO = selectedBusinessDTO;
    localStorage.setItem('selected-business', JSON.stringify(selectedBusinessDTO));
  }

  public getSelectedBusiness(): BusinessDto {
    if (this.selectedBusinessDTO) {
      return this.selectedBusinessDTO;
    } else if (localStorage.getItem('selected-business')) {
      this.selectedBusinessDTO = JSON.parse(localStorage.getItem('selected-business'));
      return this.selectedBusinessDTO;
    } else {
      return null;
    }
  }

  public createBusiness(businessDto: BusinessDto): Observable<any> {
    return this.authHttp.post(environment.BACKEND_ROOT_SERVICE + "business", businessDto);
  }

  public getBusiness(businessId: string): Observable<any> {
    return this.authHttp.get(environment.BACKEND_ROOT_SERVICE + "business/" + businessId);
  }

  public updateBusinessMenu(businessId: string, menuDto: MenuDto) {
    return this.authHttp.put(environment.BACKEND_ROOT_SERVICE + "business/menu/" + businessId, menuDto);
  }

  public updateBusinessPreferences(businessId: string, preferencesDto: PreferencesDto) {
      return this.authHttp.put(environment.BACKEND_ROOT_SERVICE + "business/preferences/" + businessId, preferencesDto);
    }

  public updateBankAccount(businessId: string, bankAccountDto: BankAccountDto) {
    return this.authHttp.put(environment.BACKEND_ROOT_SERVICE + "business/bank/" + businessId, bankAccountDto);
  }

  public updateBusinessDetails(businessId: string, name: string, website: string, addressDto: AddressDto) {
    return this.authHttp.put(environment.BACKEND_ROOT_SERVICE + "business/" + businessId +
      "?name=" + name + "&website=" + website, addressDto);
  }

  public updateStaffUserPhone(businessId: string, phoneNo: string) {
    return this.authHttp.put(environment.BACKEND_ROOT_SERVICE + "business/" + businessId +
      "/staff-user/change-phone/?phoneNo=" + phoneNo, null);
  }
}
